module.exports = __webpack_public_path__ + "img/pic_an_xzh@2x(2).ceb4fe42.png";